import { InjectionToken } from '@angular/core';
import { IFpCorrelationTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-tab-connect-service';

export const FP_CORRELATION_TAB_CONNECT_SERVICES = new InjectionToken<IFpCorrelationTabConnectService[]>(
  'FP_CORRELATION_TAB_CONNECT_SERVICES',
  {
    factory: () => {
      return [];
    },
  }
);
